// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.9 7.1C5.95 6.33 6.8 5.18 7.29 3.84L7.82 2.4C7.99 1.94 8.41 1.75 8.85 1.98C10.06 2.62 10.43 3.87 9.96 5.25L9.35 7H12.45C13.66 7 14.38 7.75 14.16 8.94L13.55 11.95C13.3 13.17 12.43 13.8 11.12 13.8H7.3C6.42 13.8 5.65 13.58 4.9 13.1',
  'M4.9 7.1H3.25C2.28 7.1 1.5 7.88 1.5 8.85V11.45C1.5 12.42 2.28 13.2 3.25 13.2H4.9V7.1Z',
];
